import React, { useEffect, useState } from "react";
import { FaWifi } from "react-icons/fa";

function InternetConnectivity() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);
  const [message, setMessage] = useState("");
  const [bgColor, setBgColor] = useState("bg-red-600");

  useEffect(() => {
    if (!navigator.onLine) {
      setMessage("No Internet Connection");
      setBgColor("bg-red-600");
      setShowBanner(true);
    }

    const handleOnline = () => {
      setIsOnline(true);
      setMessage("Back Online");
      setBgColor("bg-green-500");
      setShowBanner(true);

      setTimeout(() => {
        setShowBanner(false);
      }, 2000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setMessage("No Internet Connection");
      setBgColor("bg-red-600");
      setShowBanner(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div
      className={`fixed top-4 left-1/2 transform -translate-x-1/2 px-6 py-3 flex items-center gap-3 text-white font-semibold rounded-xl shadow-lg z-[9999999] transition-all duration-500 ease-in-out ${bgColor} ${
        showBanner ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-10"
      }`}
    >
      {isOnline ? (
        <FaWifi className="text-xl animate-pulse" />
      ) : (
        <div className="w-5 h-5 border-2 border-dashed border-white rounded-full animate-spin" />
      )}
      <span>{message}</span>
    </div>
  );
}

export default InternetConnectivity;
